import {
  LoginRequest,
  clearCookies,
  getProfileLocal,
  getUserLocal,
  setProfileLocal,
  setUserLocal,
} from "../utils/components";
import { createContext, useState } from "react";

import { Api } from "./api";
import axios from "axios";
import { message } from "antd";

export const UserContext = createContext();

export const AuthProvider = ({ children }) => {

  const [loading, setLoading] = useState(false);

  const [profile, setProfile] = useState(getProfileLocal() || false);
  const [user, setUser] = useState(getUserLocal() || false);

  const login = async (email, password, remember) => {


    try {
      const res = await LoginRequest(email, password, remember);

      let isStudent = false

      res.forEach((perfil) => {
        if (perfil.roles?.find((item) => !!item.is_panel)) isStudent = true
      });

      if (isStudent && res?.length <= 1 && res[0]?.roles?.length === 1) {
        message.error("Você não tem permissão para acessar a área de gestão");
        logout();
        return
      }

      const has_only_one_profile = res.length === 1 && res[0]?.roles?.length === 1

      if (has_only_one_profile) {
        const actual_profile = res[0]?.roles[0]
        const selectedFranchise = res[0]
        try {
          axios.defaults.headers.post["Access-Control-Allow-Origin"] = "true";

          const { data } = await Api.post(`/authenticate-as`,
            {
              role_id: actual_profile?.id,
              franchise_hash: selectedFranchise?.hash,
            },
            {
              withCredentials: true,
              xsrfCookieName: "XSRF-TOKEN",
              xsrfHeaderName: "X-XSRF-TOKEN",
            }
          );
          actual_profile.abilities = data.abilities;

          setProfile({
            ...actual_profile,
            user: data.user,
            role_id: actual_profile.id,
            franchise_id: selectedFranchise.id,
            franchise_name: data.franchise,
            type: selectedFranchise.type_company,
            nickname: data.franchise,
            slug: selectedFranchise?.slug,
          });

          setProfileLocal({
            ...actual_profile,
            user: data.user,
            role_id: actual_profile.id,
            franchise_id: selectedFranchise.id,
            franchise_name: data.franchise,
            type: selectedFranchise.type_company,
            nickname: data.franchise,
            slug: selectedFranchise?.slug,
          });
        } catch (error) {
          console.log(error);
        }
      }

      if (res.length !== 0) {
        setUser(res);
        setUserLocal(res);
        setLoading(false);
        return;
      }

      clearCookies();

    } catch (error) {

    } finally {
      setLoading(false);
    }


  };

  const forget = async (email) => {
    try {
      await Api.get("/sanctum/csrf-cookie");
      try {
        await Api.post(
          "/forgot-password",
          { email },
          {
            headers: {
              xsrfCookieName: "XSRF-TOKEN",
              xsrfHeaderName: "X-XSRF-TOKEN",
            },
          }
        );

        return true;
      } catch (error) {
        return false;
      }
    } catch (error) {
      console.log(error);
    }
  };

  const logout = async () => {
    try {
      await Api.post("/logout");
    } catch (error) {
      console.log(error)
    } finally {
      new Promise((resolve, reject) => {
        resolve(clearCookies());
      }).then(() => {
        setUser(false)
        setProfile(false)
      })
    }
  };

  return (
    <UserContext.Provider
      value={{
        login,
        logout,
        forget,
        user,
        setUser,
        setUserLocal,
        loading,
        profile,
        setProfile,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
